import React, { useState, useEffect } from "react";
import RestService from "./RestService";
import GlobalHelmet from "./../../GlobalHelmet";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import Common from "./../../common.json";
import CommonBreadCum from "./CommonBreadCum";
import CustomTable from "./../../component/CustomTable";

export default function AllTimeHighStocks() {
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);

  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";

  useEffect(() => {
    setLoading(true);
    RestService.getMarketMovesData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data?.response);
      },
      mobile,
      web_token,
      "all-time-high"
    );
  }, [mobile, web_token]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <GlobalHelmet {...Common?.allTimeHighStocks} />
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <Breadcrumbs page="All Time High Stocks" />
              {!globaldata ? <Loader /> : <></>}
            </div>
            <div className="col-sm-12">
              <h1>All Time High Stocks</h1>
              <p>
                All Time High Stocks I Stocks at All Time High - Money Tree Robo
              </p>
            </div>
            <div className="col-sm-12">
              <CommonBreadCum pageName="all-time-high" />
            </div>
            <div className="col-sm-12">
              {!globaldata.getDetails ? (
                ""
              ) : (
                <>
                  <CustomTable
                    key={globaldata.setColumn.dataField}
                    columndata={
                      globaldata.setColumn ? globaldata.setColumn : ""
                    }
                    marketdata={
                      globaldata.getDetails ? globaldata.getDetails : ""
                    }
                    redirectlink="/stocks/"
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
